import React from "react";
import {
  Grid,
  Typography,
  Container,
  CssBaseline,
  AppBar,
  Card
} from "@material-ui/core";

import "./checkout.css"
import logo from "../../images/images.jpeg"
import shield from "../../images/security.png"
import safechckout_line from "../../images/safecheckout_line.webp"
import saved from "../../images/saved_en.webp"
import banner from "../../images/long_banner.jpeg"
import paypal_btn from "../../images/paypal_btn.webp"
import safecheckout from "../../images/safecheckout.png"

const productArr = [
  {id:"1", productName:"Product One", productDescription: "Product One Description", productPrice: "1000.00", regularPrice: "9999.99", recommendedDeal: true},
  {id:"2", productName:"Product Two", productDescription: "Product Two Description", productPrice: "2000.00", regularPrice: "9999.99", recommendedDeal: false}
]

const testimonialArr = [
  {customerName: "Customer One", customerReview: "Good Product", customerImage:"1"},
  {customerName: "Customer Two", customerReview: "Best Product", customerImage:"2"},
  {customerName: "Customer Three", customerReview: "Bester Product", customerImage:"3"}
]

const selectedItem = [
  
]

const handleChecked = (id, event) => {
  let className = "choice-selection-wrap-" + id
};

const Checkout = () => {
  return (
    <div className="root">
      <div className="container">
        <div className="head-banner-wrap">
          <div className="head-banner">
            <p>Mega Discount</p>
          </div>
        </div>
        <div className="container">
          <div className="logo-banner-wrap">
            <img src={logo} alt="logo" />
          </div>
          <div className="secure-checkout-banner">
            <div className="secure-checkout-wrap">
              <span className="secure-checkout-image-wrap">
                <img src={shield} alt="logo"/>
                <p>Secure Checkout</p>
              </span>
            </div>
            <div style={{textAlign:"center", backgroundColor:"lightgray"}}>
              <span>
                <img src={safechckout_line}/>
              </span>
            </div>
          </div>
          <div className="process-state-bar">
            <div className="process-state-wrap" style={{textAlign:"center"}}>
              <span style={{display:"inline-flex"}}>
                <p style={{marginRight:10}}>Checkout</p><p style={{marginRight:10}}>&#8250;</p><p style={{color:"gray"}}>Order Receipt</p>
              </span>
            </div>
          </div>
          <div className="product-banner-one">
            <img src={banner} />
          </div>
          <div className="container" style={{maxWidth: "70%", marginTop:20}}>
            <div className="order-quantity-box">
              <div className="step-title">
                <p>Step 1: <b>Select Order Quantity</b></p>
              </div>
              <div className="choice-selection">
                <div className="choice-selection-box">
                  {/* FOR LOOP THIS CHOICE-SELECTION-WRAP WITH JS */}
                  {productArr.map((product) => (
                    <div className="choice-selection-wrap" ref={"choice-selection-wrap-"+product.id}>
                      <span className="checkbox-title">
                        <label className="checkbox-label">
                          <input type="checkbox" className="checkbox" onChange={(e) => handleChecked(product.id, e)}/>
                          <span className="checkmark"></span>
                        </label>
                        <b style={{marginLeft:30, marginRight:10}}>{product.productName}</b>
                        -
                        <p className="item-description" style={{marginLeft:10}}>{product.productDescription}</p>
                      </span>
                      <div className="image-quantity">
                        {/* image src can change with product.productImage */}
                        <img src={logo}/>
                      </div>
                      <div className="price-description">
                        <div className="deal-description">
                          {product.recommendedDeal &&
                            <span style={{display:"inline-flex"}}><p className="asterik"> * </p>Recommended Deal</span>
                          }
                        </div>
                        <div className="regular-price-description">
                          <del> {product.regularPrice} </del>
                        </div>
                        <div className="deal-price-description">
                          <b> {product.productPrice} </b>
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* <div className="choice-selection-wrap">
                    <span className="checkbox-title">
                      <label className="checkbox-label">
                        <input type="checkbox" className="checkbox" />
                        <span className="checkmark"></span>
                      </label>
                      <b style={{marginLeft:30, marginRight:10}}>TITLE</b>
                      -
                      <p className="item-description" style={{marginLeft:10}}>Description for this selection</p>
                    </span>
                    <div className="image-quantity">
                      <img src={logo}/>
                    </div>
                    <div className="price-description">
                      <div className="deal-description">
                        <span className="asterik"> * </span>Recommended Deal
                      </div>
                      <div className="regular-price-description">
                        <del>Regular Price Description</del>
                      </div>
                      <div className="deal-price-description">
                        <b>Deal Price Description</b>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="product-banner-three-wrap">
                <img src={banner} />
              </div>
            </div>
            <div className="order-details-box">
                <div className="step-title">
                  <p>Step 2: <b>Payment Methods</b></p>
                </div>
              <div className="order-overview-wrap">
                <div className="step-title">
                  <div classNme="item-verticle-box" style={{width:"69%", float:"left"}}>
                    <b>Item</b>
                  </div>
                  <div className="amount-verticle-box" style={{width:"29%", float:"right"}}>
                    <b>Amount</b>
                  </div>
                </div>
                <div className="item-cart-details">
                  <div classNme="item-verticle-box" style={{width:"69%", float:"left"}}>
                    Item Name
                    <p className="item-desc">Item Description For Long Long Long Description </p>
                  </div>
                  <div className="amount-verticle-box" style={{width:"29%", float:"right"}}>
                    $0000.00
                  </div>
                </div>
                <div className="shipping-cart-details">
                  <div classNme="item-verticle-box" style={{width:"69%", float:"left"}}>
                    Shipping:
                  </div>
                  <div className="amount-verticle-box" style={{width:"29%", float:"right"}}>
                    $0000.00
                  </div>
                </div>
              </div>
              <div className="total-amount-box">
                <div className="total-amount-wrap">
                  <div className="total-amount-left">
                    <img src={saved} className="total-amount-img" />
                  </div>
                  <div className="total-amount-right">
                    <div className="total-amount-discount">
                      <p>Discount: -$00.00</p>
                    </div>
                    <div className="total-amount-final-price">
                      <p>Grand Total: $00.00</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="product-banner-two-wrap">
                <img src={banner} />
              </div>
              <div className="payment-button-wrap">
                <input type="image" src={paypal_btn} className="payment-button-input"/>
              </div>
              <div className="guarantee-safe-checkout-wrap">
                <div className="guarantee-safe-checkout">
                  <span>
                    GUARANTEE SAFE CHECKOUT
                  </span>
                </div>
                <div className="guarantee-safe-checkout-verified">
                  <img src={safecheckout} />
                </div>
                <div className="guarantee-safe-checkout-description">
                    <p>
                      All pricing is in <b>United States Dollars.</b>
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container card-container">
          <div className="card-row">
            {testimonialArr.map((testimonial) => (
              <div className="card-col">
                <div className="card-testimonial">
                  {/* image src can change with testimonial.customerImage */}
                  <img src={logo} alt="" />
                  <div className="person-name"> {testimonial.customerName} </div>
                  <div className="rating-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                  <p> { testimonial.customerReview }</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="container footer-container">
          <p className="footer-company-name">©2021 - ProductName™</p>
          <span className="footer-link">
            <p>
                Terms & Conditions
              |
                Privacy Policy
              |
                Contact Us
            </p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Checkout;